// extracted by mini-css-extract-plugin
export var divider = "_in-0";
export var systemMessage = "_in-1";
export var systemMessageWrapper = "_in-2";